import { render, staticRenderFns } from "./UserCreater.vue?vue&type=template&id=1c70fd06&scoped=true"
import script from "./UserCreater.vue?vue&type=script&lang=js"
export * from "./UserCreater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70fd06",
  null
  
)

export default component.exports